import * as GetTestimonialTypes from 'src/actions/testimonial/get/Types';
import Testimonial from 'src/entities/Testimonial';
import { GetTestimonialAction, GetTestimonialSuccess } from 'src/actions/testimonial/get/GetTestimonial.actions';

export interface GetTestimonialState {
  testimonial?: Testimonial;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetTestimonialState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetTestimonialReducer(state: GetTestimonialState = initialState,
                                      action: GetTestimonialAction): GetTestimonialState {
  switch (action.type) {
    case GetTestimonialTypes.GET_TESTIMONIAL_ATTEMPT:
      return {...state, testimonial: undefined, loading: true, error: false};
    case GetTestimonialTypes.GET_TESTIMONIAL_SUCCESS:
      const testimonial: Testimonial = (action as GetTestimonialSuccess).payload;
      return {...state, testimonial: testimonial, loading: false, error: false};
    case GetTestimonialTypes.GET_TESTIMONIAL_FAILURE:
      return {
        ...state,
        testimonial: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/testimonial/GetTestimonialReducer.tsx